const LIST_NAME = 'PROGRAM_DISCOUNTS_LIST'

export default {
  LIST_NAME
}
